/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiBaseScreeningAlertStatus,
    InternalApiBaseScreeningAlertStatusFromJSON,
    InternalApiBaseScreeningAlertStatusToJSON,
    InternalApiScreeningAlertStatus,
    InternalApiScreeningAlertStatusFromJSON,
    InternalApiScreeningAlertStatusToJSON,
    InternalApiStatusSortOrderByType,
    InternalApiStatusSortOrderByTypeFromJSON,
    InternalApiStatusSortOrderByTypeToJSON,
} from '../models';

export interface CreateStatusRequest {
    internalApiBaseScreeningAlertStatus: InternalApiBaseScreeningAlertStatus;
}

export interface DeleteStatusRequest {
    statusId: number;
}

export interface SortStatusesOrderByTypeRequest {
    internalApiStatusSortOrderByType: InternalApiStatusSortOrderByType;
}

export interface UpdateStatusRequest {
    statusId: number;
    internalApiBaseScreeningAlertStatus: InternalApiBaseScreeningAlertStatus;
}

/**
 * 
 */
export class ScreeningAlertStatusesApi extends runtime.BaseAPI {

    /**
     * Create new status
     */
    async createStatusRaw(requestParameters: CreateStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningAlertStatus>> {
        if (requestParameters.internalApiBaseScreeningAlertStatus === null || requestParameters.internalApiBaseScreeningAlertStatus === undefined) {
            throw new runtime.RequiredError('internalApiBaseScreeningAlertStatus','Required parameter requestParameters.internalApiBaseScreeningAlertStatus was null or undefined when calling createStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-alert-statuses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiBaseScreeningAlertStatusToJSON(requestParameters.internalApiBaseScreeningAlertStatus),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningAlertStatusFromJSON(jsonValue));
    }

    /**
     * Create new status
     */
    async createStatus(requestParameters: CreateStatusRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningAlertStatus> {
        const response = await this.createStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete existing status
     */
    async deleteStatusRaw(requestParameters: DeleteStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.statusId === null || requestParameters.statusId === undefined) {
            throw new runtime.RequiredError('statusId','Required parameter requestParameters.statusId was null or undefined when calling deleteStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-alert-statuses/{statusId}`.replace(`{${"statusId"}}`, encodeURIComponent(String(requestParameters.statusId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete existing status
     */
    async deleteStatus(requestParameters: DeleteStatusRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Get all screening statuses for organisation
     */
    async findAllStatusesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningAlertStatus>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningAlertStatusFromJSON));
    }

    /**
     * Get all screening statuses for organisation
     */
    async findAllStatuses(initOverrides?: RequestInit): Promise<Array<InternalApiScreeningAlertStatus>> {
        const response = await this.findAllStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates alert statuses sort order by alert type
     */
    async sortStatusesOrderByTypeRaw(requestParameters: SortStatusesOrderByTypeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiScreeningAlertStatus>>> {
        if (requestParameters.internalApiStatusSortOrderByType === null || requestParameters.internalApiStatusSortOrderByType === undefined) {
            throw new runtime.RequiredError('internalApiStatusSortOrderByType','Required parameter requestParameters.internalApiStatusSortOrderByType was null or undefined when calling sortStatusesOrderByType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-statuses/sort-order-by-type`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiStatusSortOrderByTypeToJSON(requestParameters.internalApiStatusSortOrderByType),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiScreeningAlertStatusFromJSON));
    }

    /**
     * Updates alert statuses sort order by alert type
     */
    async sortStatusesOrderByType(requestParameters: SortStatusesOrderByTypeRequest, initOverrides?: RequestInit): Promise<Array<InternalApiScreeningAlertStatus>> {
        const response = await this.sortStatusesOrderByTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update existing status
     */
    async updateStatusRaw(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningAlertStatus>> {
        if (requestParameters.statusId === null || requestParameters.statusId === undefined) {
            throw new runtime.RequiredError('statusId','Required parameter requestParameters.statusId was null or undefined when calling updateStatus.');
        }

        if (requestParameters.internalApiBaseScreeningAlertStatus === null || requestParameters.internalApiBaseScreeningAlertStatus === undefined) {
            throw new runtime.RequiredError('internalApiBaseScreeningAlertStatus','Required parameter requestParameters.internalApiBaseScreeningAlertStatus was null or undefined when calling updateStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-alert-statuses/{statusId}`.replace(`{${"statusId"}}`, encodeURIComponent(String(requestParameters.statusId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiBaseScreeningAlertStatusToJSON(requestParameters.internalApiBaseScreeningAlertStatus),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningAlertStatusFromJSON(jsonValue));
    }

    /**
     * Update existing status
     */
    async updateStatus(requestParameters: UpdateStatusRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningAlertStatus> {
        const response = await this.updateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
